export default __webpack_public_path__ + "static/media/mixology-mobile-pattern@2x.dc6fcd1d.png";